/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { CreateMediaOutputDTO } from '../../../shared/types/api/createMediaOutputDTO';

import type { CreateMediaRestInputDTO } from '../../../shared/types/api/createMediaRestInputDTO';

import type { GetMediaOutputDTO } from '../../../shared/types/api/getMediaOutputDTO';

import type { HTTPValidationError } from '../../../shared/types/api/hTTPValidationError';

import type { SearchMediaApiV1MediaGetParams } from '../../../shared/types/api/searchMediaApiV1MediaGetParams';

import type { SearchMediaOutputDTO } from '../../../shared/types/api/searchMediaOutputDTO';

import type { UpdateMediaRestInputDTO } from '../../../shared/types/api/updateMediaRestInputDTO';

import { customInstance } from '../../../shared/api/api-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create Media
 */
export const createMediaApiV1MediaPost = (
  createMediaRestInputDTO: CreateMediaRestInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateMediaOutputDTO>(
    {
      url: `/api/v1/media/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createMediaRestInputDTO,
      signal,
    },
    options
  );
};

export const getCreateMediaApiV1MediaPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
    TError,
    { data: CreateMediaRestInputDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
  TError,
  { data: CreateMediaRestInputDTO },
  TContext
> => {
  const mutationKey = ['createMediaApiV1MediaPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
    { data: CreateMediaRestInputDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createMediaApiV1MediaPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMediaApiV1MediaPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>
>;
export type CreateMediaApiV1MediaPostMutationBody = CreateMediaRestInputDTO;
export type CreateMediaApiV1MediaPostMutationError = HTTPValidationError;

/**
 * @summary Create Media
 */
export const useCreateMediaApiV1MediaPost = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
      TError,
      { data: CreateMediaRestInputDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMediaApiV1MediaPost>>,
  TError,
  { data: CreateMediaRestInputDTO },
  TContext
> => {
  const mutationOptions = getCreateMediaApiV1MediaPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search Media
 */
export const searchMediaApiV1MediaGet = (
  params?: SearchMediaApiV1MediaGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SearchMediaOutputDTO>(
    { url: `/api/v1/media/`, method: 'GET', params, signal },
    options
  );
};

export const getSearchMediaApiV1MediaGetQueryKey = (params?: SearchMediaApiV1MediaGetParams) => {
  return [`/api/v1/media/`, ...(params ? [params] : [])] as const;
};

export const getSearchMediaApiV1MediaGetQueryOptions = <
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchMediaApiV1MediaGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>> = ({
    signal,
  }) => searchMediaApiV1MediaGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchMediaApiV1MediaGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
>;
export type SearchMediaApiV1MediaGetQueryError = HTTPValidationError;

export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params: undefined | SearchMediaApiV1MediaGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
          TError,
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
          TError,
          Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Media
 */

export function useSearchMediaApiV1MediaGet<
  TData = Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>,
  TError = HTTPValidationError,
>(
  params?: SearchMediaApiV1MediaGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchMediaApiV1MediaGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchMediaApiV1MediaGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Media
 */
export const getMediaApiV1MediaMediaUidGet = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetMediaOutputDTO>(
    { url: `/api/v1/media/${mediaUid}`, method: 'GET', signal },
    options
  );
};

export const getGetMediaApiV1MediaMediaUidGetQueryKey = (mediaUid?: string) => {
  return [`/api/v1/media/${mediaUid}`] as const;
};

export const getGetMediaApiV1MediaMediaUidGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMediaApiV1MediaMediaUidGetQueryKey(mediaUid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>> = ({
    signal,
  }) => getMediaApiV1MediaMediaUidGet(mediaUid, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!mediaUid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMediaApiV1MediaMediaUidGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
>;
export type GetMediaApiV1MediaMediaUidGetQueryError = HTTPValidationError;

export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
          TError,
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
          TError,
          Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Media
 */

export function useGetMediaApiV1MediaMediaUidGet<
  TData = Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>,
  TError = HTTPValidationError,
>(
  mediaUid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMediaApiV1MediaMediaUidGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMediaApiV1MediaMediaUidGetQueryOptions(mediaUid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Media
 */
export const updateMediaApiV1MediaMediaUidPatch = (
  mediaUid: string,
  updateMediaRestInputDTO: UpdateMediaRestInputDTO,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>(
    {
      url: `/api/v1/media/${mediaUid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMediaRestInputDTO,
    },
    options
  );
};

export const getUpdateMediaApiV1MediaMediaUidPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
    TError,
    { mediaUid: string; data: UpdateMediaRestInputDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
  TError,
  { mediaUid: string; data: UpdateMediaRestInputDTO },
  TContext
> => {
  const mutationKey = ['updateMediaApiV1MediaMediaUidPatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
    { mediaUid: string; data: UpdateMediaRestInputDTO }
  > = (props) => {
    const { mediaUid, data } = props ?? {};

    return updateMediaApiV1MediaMediaUidPatch(mediaUid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMediaApiV1MediaMediaUidPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>
>;
export type UpdateMediaApiV1MediaMediaUidPatchMutationBody = UpdateMediaRestInputDTO;
export type UpdateMediaApiV1MediaMediaUidPatchMutationError = HTTPValidationError;

/**
 * @summary Update Media
 */
export const useUpdateMediaApiV1MediaMediaUidPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
      TError,
      { mediaUid: string; data: UpdateMediaRestInputDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMediaApiV1MediaMediaUidPatch>>,
  TError,
  { mediaUid: string; data: UpdateMediaRestInputDTO },
  TContext
> => {
  const mutationOptions = getUpdateMediaApiV1MediaMediaUidPatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Media
 */
export const deleteMediaApiV1MediaMediaUidDelete = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>
) => {
  return customInstance<void>({ url: `/api/v1/media/${mediaUid}`, method: 'DELETE' }, options);
};

export const getDeleteMediaApiV1MediaMediaUidDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
    TError,
    { mediaUid: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
  TError,
  { mediaUid: string },
  TContext
> => {
  const mutationKey = ['deleteMediaApiV1MediaMediaUidDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
    { mediaUid: string }
  > = (props) => {
    const { mediaUid } = props ?? {};

    return deleteMediaApiV1MediaMediaUidDelete(mediaUid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMediaApiV1MediaMediaUidDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>
>;

export type DeleteMediaApiV1MediaMediaUidDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete Media
 */
export const useDeleteMediaApiV1MediaMediaUidDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
      TError,
      { mediaUid: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMediaApiV1MediaMediaUidDelete>>,
  TError,
  { mediaUid: string },
  TContext
> => {
  const mutationOptions = getDeleteMediaApiV1MediaMediaUidDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Request Media Review
 */
export const requestMediaReviewApiV1MediaMediaUidRequestReviewPost = (
  mediaUid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<unknown>(
    { url: `/api/v1/media/${mediaUid}/request-review`, method: 'POST', signal },
    options
  );
};

export const getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
    TError,
    { mediaUid: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
  TError,
  { mediaUid: string },
  TContext
> => {
  const mutationKey = ['requestMediaReviewApiV1MediaMediaUidRequestReviewPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
    { mediaUid: string }
  > = (props) => {
    const { mediaUid } = props ?? {};

    return requestMediaReviewApiV1MediaMediaUidRequestReviewPost(mediaUid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>
>;

export type RequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Request Media Review
 */
export const useRequestMediaReviewApiV1MediaMediaUidRequestReviewPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
      TError,
      { mediaUid: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof requestMediaReviewApiV1MediaMediaUidRequestReviewPost>>,
  TError,
  { mediaUid: string },
  TContext
> => {
  const mutationOptions =
    getRequestMediaReviewApiV1MediaMediaUidRequestReviewPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
